import {useGet} from "@/apiHooks/HttpFunctions";
import {countryManagementApi, webUserMutationApi, webUsersApi} from "@/apis/apis";
import {FILTER_TYPE} from "@/constant/constants";
import {booleanOptionFilters} from "@/constant/GeneralOptions/boolean";
import {userTypeFilters} from "@/constant/Users/types";
import React, {useCallback, useMemo, useState} from "react";
import BaseTable from "../BaseTable";
import Actions from "./Actions";
import {columns} from "./Columns";
import {LIST_MODE} from "@/constant/Lists/listMode";
import {USER_STATUS} from "@/constant/Users/status";
import WebUserMutationModal from "@/Modals/WebUserMutation";

export default function WebUsersPage() {
  const booleanOptionFiltersMap = booleanOptionFilters();
  const userTypeFiltersMap = userTypeFilters();

  const {data: countryManagementData} = useGet({
    apiURL: countryManagementApi,
    params: {
      mode: LIST_MODE.ALL,
      sort: "order",
    }
  });

  const countryOptions = [
    {value: "", label: "All"},
    ...(countryManagementData?.data?.map((supportedCountry) => {
      return {
        value: supportedCountry.country.code,
        label: supportedCountry.country.name,
      }
    }) || []),
  ]

  const additionalFilters = [
    {
      id: "filter[has_sales_py]",
      label: "Has Sales PY",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
    {
      id: "filter[has_sales_ytd]",
      label: "Has Sales YTD",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
    {
      id: "filter[primary_address.country.code]",
      label: "Country",
      type: FILTER_TYPE.SELECT,
      options: countryOptions,
    },
    {
      id: "filter[type]",
      label: "Type",
      type: FILTER_TYPE.SELECT,
      options: userTypeFiltersMap,
    },
    {
      id: "filter[newsletter_subscription]",
      label: "Newsletter?",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
    {
      id: "filter[term_conditions_accepted_at]",
      label: "T&C?",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
    {
      id: "filter[privacy_policy_accepted_at]",
      label: "Privacy Policy?",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
    {
      id: "filter[two_factor_auth_enabled]",
      label: "2-Factor Auth?",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
    {
      id: "filter[cookies_accepted]",
      label: "Cookies?",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
  ];

  const [columnConfigs, setColumnConfigs] = useState();
  const shownColumns = useMemo(() => columns(columnConfigs), [columnConfigs]);

  const [mutationModal, setMutationModal] = useState({
    isOpen: false,
    header: "",
    text: "",
    endpointUrl: "",
    userId: 0,
    userStatus: USER_STATUS.BLOCKED,
  });
  const handleChangeStatus = useCallback((row) => {
    const action = row.status === USER_STATUS.BLOCKED ? "reactivate" : "restrict";
    setMutationModal({
      header: row.status === USER_STATUS.BLOCKED ? "Reactivate User" : "Restrict User",
      endpointUrl: `${webUserMutationApi}/${action}`,
      userId: row.id,
      isOpen: true,
    });
  }, []);
  const onSuccessChangeStatus = useCallback(() => {
    setMutationModal((prev) => ({...prev, isOpen: false}));
  }, []);
  return (<>
      <BaseTable
        label="Web User List"
        apiURL={webUsersApi}
        columns={shownColumns}
        importData={null}
        enableAdd={false}
        enableEditTable={true}
        costumActions={({row}) => <Actions row={row} handleClickRestrict={handleChangeStatus}/>}
        additionalFilters={additionalFilters}
        allColumns={columns()}
        setColumnConfigs={setColumnConfigs}
      />
      <WebUserMutationModal
        headerText={mutationModal.header}
        isOpen={mutationModal.isOpen}
        userId={mutationModal.userId}
        onSuccess={onSuccessChangeStatus}
        endpointUrl={mutationModal.endpointUrl}
      />
    </>
  );
}
